import { createAsyncThunk } from '@reduxjs/toolkit';
import refinanceService from './refinanceService';
import { restructureErrorMessage } from '../../helpers/errorMessage';

export const getAllRefinancesThunk = createAsyncThunk(
  'refinance/getAllRefinances',
  async (requestData: any, thunkAPI) => {
    try {
      return await refinanceService.getAllRefinances(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getOpenRefinancesThunk = createAsyncThunk(
  'refinance/getOpenRefinances',
  async (requestData: any, thunkAPI) => {
    try {
      return await refinanceService.getOpenRefinances(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getPendingRefinancesThunk = createAsyncThunk(
  'refinance/getPendingRefinances',
  async (requestData: any, thunkAPI) => {
    try {
      return await refinanceService.getPendingRefinances(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getReferbackRefinancesThunk = createAsyncThunk(
  'refinance/getReferbackRefinances',
  async (requestData: any, thunkAPI) => {
    try {
      return await refinanceService.getReferbackRefinances(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getApprovedRefinancesThunk = createAsyncThunk(
  'refinance/getApprovedRefinances',
  async (requestData: any, thunkAPI) => {
    try {
      return await refinanceService.getApprovedRefinances(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getRejectedRefinancesThunk = createAsyncThunk(
  'refinance/getRejectedRefinances',
  async (requestData: any, thunkAPI) => {
    try {
      return await refinanceService.getRejectedRefinances(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getCancelledRefinancesThunk = createAsyncThunk(
  'refinance/getCancelledRefinances',
  async (requestData: any, thunkAPI) => {
    try {
      return await refinanceService.getCancelledRefinances(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getSubmitForApprovalRefinancesThunk = createAsyncThunk(
  'refinance/getSubmitForApprovalRefinances',
  async (requestData: any, thunkAPI) => {
    try {
      return await refinanceService.getSubmitForApprovalRefinances(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getApprovedReviewRefinancesThunk = createAsyncThunk(
  'refinance/getApprovedReviewRefinances',
  async (requestData: any, thunkAPI) => {
    try {
      return await refinanceService.getApprovedReviewRefinances(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getRefinanceFinanceListingThunk = createAsyncThunk(
  'refinance/getRefinanceFinanceListing',
  async (requestData: any, thunkAPI) => {
    try {
      return await refinanceService.getRefinanceFinanceListing(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getRefinanceDetailsThunk = createAsyncThunk(
  'refinance/getDetails',
  async (requestData: any, thunkAPI) => {
    try {
      return await refinanceService.getRefinanceDetails(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getRefinanceDetailsByApplicationIdThunk = createAsyncThunk(
  'refinance/getDetailsByApplicationId',
  async (requestData: any, thunkAPI) => {
    try {
      return await refinanceService.getRefinanceDetailsByApplicationId(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getRefinanceDetailsByAgreementIdThunk = createAsyncThunk(
  'refinance/getDetailsByAgreementId',
  async (requestData: any, thunkAPI) => {
    try {
      return await refinanceService.getRefinanceDetailsByAgreementId(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getCompletedRefinanceDetailsByOldAgreementNoThunk = createAsyncThunk(
  'refinance/getCompletedRefinanceDetailsByOldAgreementNo',
  async (requestData: any, thunkAPI) => {
    try {
      return await refinanceService.getCompletedRefinanceDetailsByOldAgreementNoThunk(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createRefinanceThunk = createAsyncThunk(
  'refinance/create',
  async (requestData: any, thunkAPI) => {
    try {
      return await refinanceService.createRefinance(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateRefinanceEffectiveDateThunk = createAsyncThunk(
  'refinance/updateEffectiveDate',
  async (requestData: any, thunkAPI) => {
    try {
      return await refinanceService.updateRefinanceEffectiveDate(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateRefinanceRefinanceFeeThunk = createAsyncThunk(
  'refinance/updateRefinanceFee',
  async (requestData: any, thunkAPI) => {
    try {
      return await refinanceService.updateRefinanceFee(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
